import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { ToastContainer } from "react-toastify";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import ContentRoutes from "./routes/ContentRoutes";
import newLogin from "./pages/login/newLogin";
import register from "./pages/login/register";
import verifyPassword from "./pages/login/verifyPassword";
import forgotPassword from "./pages/login/forgotPassword";

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#2CB96A",
      contrastText: "#FFFFFF",

      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },

    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

Object.assign(theme, {
  overrides: {
    MUIRichTextEditor: {
      container: {
        marginTop: 20,
        border: "1px solid #EFF0F2",
        minHeight: 300,
        borderRadius: 5,
        backgroundColor: "#FCFCFC",
      },
      toolbar: {
        // backgroundColor: "red",
        borderBottom: "1px solid #EFF0F2",
      },
      root: {
        width: "100%",
      },
      editorContainer: {
        padding: 20,
        fontFamily: "Circular Std Book",
        fontSize: 14,
        lineHeight: 1.6,
        color: "#7F8388",
      },
    },
  },
});


class App extends Component {
  render() {
    return (
      <>
        <ThemeProvider theme={theme}>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
          />
          <Switch>
            <Route path="/login" exact component={newLogin} />
            <Route path="/register" exact component={register} />
            <Route
              path="/forgot-password"
              exact
              component={forgotPassword}
            />
            <Route
              path="/verifikasi/:token"
              exact
              component={verifyPassword}
            />
            <Route component={ContentRoutes} />
          </Switch>
        </ThemeProvider>
      </>
    );
  }
}

export default App;
